import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const listPolicyMixin = {
  data() {
    return {
      apiUrl: undefined,
      totalItems: 0,
      totalCargoItems: 0,
      totalFireItems: 0,
      totalHullItems: 0,
      totalMedItems: 0,
      totalPaItems: 0,
      totalMiscItems: 0,
      totalMotorItems: 0,
      totalAllClassItems: 0,
      selectedPage: 0
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    listState() {
      return this.$store.state.underwriting.menu
    },
    listPolicyHeaders() {
      let result = []
      for (const selectedPolicyColumn of this.selectedPolicyColumns) {
        let findCol = this.policyColumns.find(a => selectedPolicyColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listPolCargoRiskHeaders() {
      let result = []
      for (const selectedPolCargoRiskColumn of this.selectedPolCargoRiskColumns) {
        let findCol = this.polCargoRiskColumns.find(a => selectedPolCargoRiskColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listPolFireRiskHeaders() {
      let result = []
      for (const selectedPolFireRiskColumn of this.selectedPolFireRiskColumns) {
        let findCol = this.polFireRiskColumns.find(a => selectedPolFireRiskColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listPolHullRiskHeaders() {
      let result = []
      for (const selectedPolHullRiskColumn of this.selectedPolHullRiskColumns) {
        let findCol = this.polHullRiskColumns.find(a => selectedPolHullRiskColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listPolMedRiskHeaders() {
      let result = []
      for (const selectedPolMedRiskColumn of this.selectedPolMedRiskColumns) {
        let findCol = this.polMedRiskColumns.find(a => selectedPolMedRiskColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listPolPaRiskHeaders() {
      let result = []
      for (const selectedPolPaRiskColumn of this.selectedPolPaRiskColumns) {
        let findCol = this.polPaRiskColumns.find(a => selectedPolPaRiskColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listPolMiscRiskHeaders() {
      let result = []
      for (const selectedPolMiscRiskColumn of this.selectedPolMiscRiskColumns) {
        let findCol = this.polMiscRiskColumns.find(a => selectedPolMiscRiskColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listPolMotorRiskHeaders() {
      let result = []
      for (const selectedPolMotorRiskColumn of this.selectedPolMotorRiskColumns) {
        let findCol = this.polMotorRiskColumns.find(a => selectedPolMotorRiskColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listAllClassRiskHeaders() {
      let result = []
      for (const selectedAllClassRiskColumn of this.selectedAllClassRiskColumns) {
        let findCol = this.allClassRiskColumns.find(a => selectedAllClassRiskColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    listSurveyHeaders() {
      let result = []
      for (const selectedSurveyColumn of this.selectedSurveyColumns) {
        let findCol = this.surveyColumns.find(a => selectedSurveyColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function(value) {
      if (this.isAfterDefFilter === true) {
        this.fetchData(false)
      }
    }
  },
  mounted() {
    // AR: Not Required - Duplicate Call 21Nov20
    // this.fetchData(true)
  },
  mixins: [TableConst.default, MessageMixin]
}
